module.exports = __webpack_public_path__ + "img/Qdiamonds.8041f3c5.jpg";